import axios from 'axios';

// The default 10 s timeout cuts off a 5 MB file on a slow link.
export const UPLOAD_TIMEOUT_MS = 120_000;

export function getApiClient(token?: string) {
  const apiClient = axios.create({
    timeout: 10000,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  apiClient.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor for error handling
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response?.status === 401 &&
        window.location.pathname !== '/signin'
      ) {
        const currentUrl = window.location.pathname + window.location.search;
        const redirectTo = encodeURIComponent(currentUrl);
        location.href = `/signin?redirect=${redirectTo}`;
      }
      return Promise.reject(error);
    }
  );

  return apiClient;
}
